module.exports = __webpack_public_path__ + "static/media/globo-compuerta-05.db67ca67.png";